import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useSponsorsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'sponsors', api: api.sponsors }, queryVariables, queryConfig);

  return {
    sponsors: queryResult.resolvedData,
    latestSponsors: queryResult.latestData,
    ...queryResult,
  };
};

export const useSponsor = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['sponsor', { id }], api.sponsors.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    sponsor: queryResult.data || {},
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'sponsors' });

export const useDeleteSponsor = createMutation(api.sponsors.remove);

export const useCreateSponsor = createMutation(api.sponsors.create);

export const useSaveSponsor = createMutation(api.sponsors.save);

export const useUpdateSponsor = createMutation(api.sponsors.update);
